import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import enGlobal from '@assets/locales/en.json'
import ptGlobal from '@assets/locales/pt.json'
import esGlobal from '@assets/locales/es.json'
import enDefault from '@layouts/login/locales/en.json'
import ptDefault from '@layouts/login/locales/pt.json'
import esDefault from '@layouts/login/locales/es.json'
import enLoginPage from '@pages/login/locales/en.json'
import ptLoginPage from '@pages/login/locales/pt.json'
import esLoginPage from '@pages/login/locales/es.json'
import enRegisterPage from '@pages/register/locales/en.json'
import ptRegisterPage from '@pages/register/locales/pt.json'
import esRegisterPage from '@pages/register/locales/es.json'
import enVerifyPage from '@pages/verify/locales/en.json'
import ptVerifyPage from '@pages/verify/locales/pt.json'
import esVerifyPage from '@pages/verify/locales/es.json'
import enBindPage from '@pages/bind/locales/en.json'
import ptBindPage from '@pages/bind/locales/pt.json'
import esBindPage from '@pages/bind/locales/es.json'
import ptForgotPassword from '@pages/forgot-password/locales/pt.json'
import esForgotPassword from '@pages/forgot-password/locales/es.json'
import enForgotPassword from '@pages/forgot-password/locales/en.json'
import enNewPassword from '@pages/new-password/locales/en.json'
import ptNewPassword from '@pages/new-password/locales/pt.json'
import esNewPassword from '@pages/new-password/locales/es.json'
import enUseDoLogin from '@hooks/use-do-login/locales/en.json'
import ptUseDoLogin from '@hooks/use-do-login/locales/pt.json'
import esUseDoLogin from '@hooks/use-do-login/locales/es.json'
import enUseMessage from '@hooks/use-message/locales/en.json'
import ptUseMessage from '@hooks/use-message/locales/pt.json'
import esUseMessage from '@hooks/use-message/locales/es.json'

export const defaultNS = 'globalLogin'
export const resources = {
  en: {
    globalLogin: enGlobal,
    loginLayout: enDefault,
    loginPage: enLoginPage,
    registerPage: enRegisterPage,
    verifyPage: enVerifyPage,
    bindPage: enBindPage,
    forgotPasswordPage: enForgotPassword,
    newPasswordPage: enNewPassword,
    useDoLogin: enUseDoLogin,
    useMessage: enUseMessage,
  },
  pt: {
    globalLogin: ptGlobal,
    loginLayout: ptDefault,
    loginPage: ptLoginPage,
    registerPage: ptRegisterPage,
    verifyPage: ptVerifyPage,
    bindPage: ptBindPage,
    forgotPasswordPage: ptForgotPassword,
    newPasswordPage: ptNewPassword,
    useDoLogin: ptUseDoLogin,
    useMessage: ptUseMessage,
  },
  es: {
    globalLogin: esGlobal,
    loginLayout: esDefault,
    loginPage: esLoginPage,
    registerPage: esRegisterPage,
    verifyPage: esVerifyPage,
    bindPage: esBindPage,
    forgotPasswordPage: esForgotPassword,
    newPasswordPage: esNewPassword,
    useDoLogin: esUseDoLogin,
    useMessage: esUseMessage,
  },
} as const

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    defaultNS,
    ns: [
      'globalLogin',
      'loginLayout',
      'loginPage',
      'registerPage',
      'verifyPage',
      'bindPage',
      'forgotPasswordPage',
      'newPasswordPage',
      'useDoLogin',
      'useMessage',
    ],
    load: 'all',
    supportedLngs: ['en', 'es', 'pt'],
    fallbackLng: 'en',
    lng: navigator.language?.split('-')[0] || 'en',
    debug: false,
    cache: {
      enabled: false,
    },
    resources,
  })

export default i18n
